import React, { Fragment, useState, useEffect } from "react";
import Pregunta from "./components/Pregunta";
import Formulario from "./components/Formulario";
import Listado from "./components/Listado";
import ControlPresupuesto from "./components/ControlPresupuesto";

function App() {
  const [presupuesto, setpresupuesto] = useState(0);
  const [restante, setrestante] = useState(0);
  const [mostrarPregunta, setmostrarPregunta] = useState(true);
  const [gastos, setgastos] = useState([]);
  const [gastoss, setgastoss] = useState({})
  const [crearGasto, setcrearGasto] = useState(false)
  //useffect agregar nuevos gastos y resta el presupuesto.
  useEffect(() => {
    
    //agregar nuevo gasto
    if(crearGasto){
      setgastos([
        ...gastos,
        gastoss
      ]);

      setcrearGasto(false);

    //restar Presupuesto
    let presupuestoRestante = restante - gastoss.cantidad;
    setrestante(presupuestoRestante);
    
    }
   

  }, [gastos,setcrearGasto,gastoss,crearGasto,restante])



  return (
    <Fragment>
      <div className="container">
        <header>
          <h1>Gasto semanales</h1>

          <div className="contenido-principal contenido">
            {mostrarPregunta ? (
              <Pregunta
                presupuesto={setpresupuesto}
                restante={setrestante}
                mostrarPregunta={setmostrarPregunta}
              />
            ) : (
              <div className="row">
                <div className="one-half column">
                  <Formulario 
                    setgastoss={setgastoss}
                    setcrearGasto={setcrearGasto}
                  />
                </div>
                <div className="one-half column">
                  <Listado
                    gastos={gastos}
                  />
                  <ControlPresupuesto
                    presupuesto={presupuesto}
                    restante = {restante}
                  />
                </div>
              </div>
            )}
          </div>
        </header>
      </div>
    </Fragment>
  );
}

export default App;
